import { Component, OnDestroy, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';


import { BriefingBlockTypeEnum } from '../../../../Monitor/Briefings/enums/briefing-block-type.enum';

import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';

import { AbstractPageBuilderService } from '../../services/abstract-page-builder.service';
import { BlockTypeModel } from '../../models/block-type.model';
import { BlockTypeGroupModel } from '../../models/block-type-group.model';

@Component({
    selector: 'agpr-block-adder',
    templateUrl: './block-adder.component.html',
    styleUrls: ['./block-adder.component.scss'],
    standalone: false
})
export class BlockAdderComponent implements OnInit, OnDestroy {

    @Input() id: string = null;
    @Input() addAtPosition: string = null;
    @Input() draggable: boolean = false;
    @Input() hideBlockTypes: string[] = [];

    @Output() blockAdded: EventEmitter<void> = new EventEmitter<void>();

    blockTypes: BlockTypeModel[] = [];
    blockTypeGroups: BlockTypeGroupModel[] = [];

    protected subscriptions: Subscription[] = [];

    readonly buttonTypes = ButtonTypesEnum;
    readonly briefingBlockTypeEnum = BriefingBlockTypeEnum;

    constructor(
        public pageBuilderService: AbstractPageBuilderService,
    ) {}

    ngOnInit() {
        this.subscriptions.push(
            this.pageBuilderService.getBlockTypes().subscribe((blockTypes) => {
                this.blockTypes = blockTypes;
            }),
            this.pageBuilderService.getBlockTypeGroups().subscribe((blockTypeGroups) => {
                this.blockTypeGroups = blockTypeGroups;
            }),
        );
    }

    addBlock(blockType: BlockTypeModel, event: Event): void {
        this.pageBuilderService.addBlockOfTypeWithEvent(blockType, this.addAtPosition, event);
    }

    onDragBlockTypeStart(blockType: BlockTypeModel): void {
        this.pageBuilderService.setDraggingBlockType(blockType);
    }

    onDragBlockTypeComplete(): void {
        this.pageBuilderService.setDraggingBlockType(null);
    }

    ngOnDestroy() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
}
